export default __webpack_public_path__ + "static/images/Momo_1_thumb.png";